import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    footer {
      color: #ffffff;
      position: relative;
      z-index: 10;
    }

    h1 {
      font-size: calc(24rem / var(--default-rem-px-count));
      line-height: calc(24rem / var(--default-rem-px-count));
      letter-spacing: -0.72px;
      font-weight: 500;
    }

    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
    }

    p,
    li,
    a {
      font-size: calc(14rem / var(--default-rem-px-count));
      line-height: calc(32rem / var(--default-rem-px-count));
      letter-spacing: -0.24px;
      padding: calc(4rem / var(--default-rem-px-count)) 0;
    }

    a {
      text-decoration: none;
      color: #ffffff;
    }

    .footer-layout {
      grid-template-rows:
        var(--top-padding-height)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        calc(20rem / var(--default-rem-px-count));
      width: 100%;
    }

    .add-top-margin {
      margin-top: calc(40rem / var(--default-rem-px-count));
    }

    .main {
      grid-row: 2;
      grid-column: 2 / 8;
    }

    .drivers {
      grid-row: 3;
      grid-column: 2 / 8;
    }

    .terms {
      grid-row: 4;
      grid-column: 2 / 8;
    }

    .main {
      display: flex;
      flex-direction: column;
    }

    .main .header {
      display: flex;
      flex-direction: column;
    }

    .section-header {
      display: flex;
      flex-direction: column;
    }

    cta-text {
      padding-top: calc(20rem / var(--default-rem-px-count));
    }

    ul.socials {
      flex-direction: row;
      padding-top: calc(40rem / var(--default-rem-px-count));
    }

    .footer-icon {
      filter: brightness(0) invert(1);
      margin-right: calc(8rem / var(--default-rem-px-count));
    }

    .drivers {
      display: flex;
      justify-content: space-between;
    }

    .driver-section {
      display: flex;
      flex-direction: column;
      max-width: 33%;
      flex-grow: 1;
    }

    .section-header {
      font-weight: 500;
      padding-bottom: calc(8rem / var(--default-rem-px-count));
    }

    .driver-section a {
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
    }

    .driver-icon {
      height: calc(18rem / var(--default-rem-px-count));
      width: calc(18rem / var(--default-rem-px-count));
    }

    .terms {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-top: calc(80rem / var(--default-rem-px-count));
    }

    .terms ul {
      flex-direction: column;
    }

    @media (min-width: 600px) {
      .footer-layout {
        grid-template-rows:
          var(--top-padding-height)
          minmax(0, auto)
          minmax(0, auto)
          minmax(0, auto)
          calc(20rem / var(--default-rem-px-count));
      }

      .main {
        grid-column: 2 / 14;
        grid-row: 2;
        flex-direction: row;
        justify-content: space-between;
      }

      .main .header {
        max-width: 50%;
      }

      ul.socials {
        padding-top: calc(0rem / var(--default-rem-px-count));
      }

      cta-text {
        padding-top: calc(20rem / var(--default-rem-px-count));
      }

      .drivers {
        grid-row: 3;
        grid-column: 2 / 12;
        padding-top: calc(40rem / var(--default-rem-px-count));
        justify-content: initial;
      }

      .driver-section {
        max-width: unset;
      }

      .terms {
        grid-row: 4;
        grid-column: 2 / 14;
        flex-direction: row;
      }

      .terms ul.right {
        display: flex;
        flex-direction: row;
        padding-right: calc(40rem / var(--default-rem-px-count));
      }

      .terms ul li:not(:last-child) {
        padding-right: calc(24rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      .footer-layout {
        grid-template-rows:
          var(--top-padding-height)
          minmax(0, auto)
          minmax(0, auto)
          calc(20rem / var(--default-rem-px-count));
      }

      .main {
        grid-column: 2 / 6;
        grid-row: 2;
        flex-direction: column;
        justify-content: initial;
      }

      .main .header {
        max-width: unset;
      }

      .drivers {
        grid-row: 2;
        grid-column: 8 / 14;
        padding-top: 0;
      }

      .terms {
        grid-row: 3;
        grid-column: 2 / 14;
      }

      ul.socials {
        padding-top: calc(40rem / var(--default-rem-px-count));
      }
    }
  `,
];
